export function resolveTextStyle(
  variant: string | undefined
): 'bodyStrong' | 'bodyMuted' | 'bodyNormal' {
  if (variant === 'strong') return 'bodyStrong';
  if (variant === 'muted') return 'bodyMuted';
  return 'bodyNormal';
}

export function resolvePdfAlignment(align?: string): 'left' | 'center' | 'right' {
  if (align === 'center' || align === 'right') {
    return align;
  }
  return 'left';
}

export function resolvePdfColumnWidth(width?: string): '*' | 'auto' | number {
  if (!width) return '*';
  if (width === 'auto') return 'auto';
  if (width.endsWith('px')) {
    const numeric = parseFloat(width);
    return Number.isFinite(numeric) ? numeric : '*';
  }
  return '*';
}

export function formatPdfCellValue(value: unknown): string {
  if (value === undefined || value === null || value === '') {
    return '—';
  }
  if (typeof value === 'string') {
    return value;
  }
  return String(value);
}
